export const BREAKPOINTS = {
   // tailwindのsm
   sm:  {
      px: 640,
      em: 40,
   },
   // tailwindのmd
   md: {
      px: 768,
      em: 48
   },
   // tailwindのlg
   lg: {
      px: 1024,
      em: 64,
   },
   // tailwindのxl
   xl: {
      px: 1280,
      em: 80,
   },
   // tailwindの2xl
   xxl: {
      px: 1536,
      em: 96,
   },
};
